import React from 'react';
import { ROUTE_URL } from '@/helper/constants';
import { NoneLayout } from '@/components';

const Home = React.lazy(
  () => import(/* webpackChunkName: "home" */ '@/pages/home'),
);

export default [
  {
    path: `${ROUTE_URL.ROOT}`,
    component: Home,
    isAuth: false,
    layout: NoneLayout,
  },
];
